import InputText from "./text";

export default InputText;
